import { destroy } from './helpers'

export default {
  deleteUser() {
    return destroy('api/users')
  }
}
